import { render, staticRenderFns } from "./securityCenter.vue?vue&type=template&id=16be26a5&scoped=true&"
import script from "./securityCenter.vue?vue&type=script&lang=js&"
export * from "./securityCenter.vue?vue&type=script&lang=js&"
import style0 from "./securityCenter.vue?vue&type=style&index=0&id=16be26a5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be26a5",
  null
  
)

export default component.exports